import StateType from './state.type';

export default {
  loading: false,
  loadingProduct: false,
  loadingModal: false,
  productInfo: null,
  stocks: [],
  total: 0,
  totalInput: 0,
  totalOutput: 0,
} as StateType;
